import React from 'react';
import styles from './styles.module.scss';
import Flex from 'src/components/Flex';
import PageContainer from 'src/components/PageContainer';
import NavBar from '../NavBar';
import PageContent from 'src/components/PageContent';
import Card from 'src/components/Card';
import LoadingIcon from 'src/components/LoadingIcon';
import { useSurveyIntegrationConfig } from 'src/queries/useSurveyIntegration';
import ConnectionStatusSection from './ConnectionStatusSection';
import ApiKeySection from './ApiKeySection';
import RoutingToggleSection from './RoutingToggleSection';
import MigrationInfoSection from './MigrationInfoSection';

function SurveyIntegration() {
    const { data: config, isLoading, error } = useSurveyIntegrationConfig();

    return (
        <PageContainer>
            <NavBar />
            <PageContent>
                <Flex self="stretch" align="center" justify="start">
                    <Flex value={1} className={styles.pageTitle}>
                        Survey Integration
                    </Flex>
                </Flex>

                {isLoading ? (
                    <Card className={styles.cardWrap}>
                        <Flex justify="center">
                            <LoadingIcon />
                        </Flex>
                    </Card>
                ) : error || !config ? (
                    <Card className={styles.cardWrap}>
                        <div className={styles.error}>
                            {error instanceof Error ? error.message : 'Failed to load integration settings'}
                        </div>
                    </Card>
                ) : (
                    <>
                        <ConnectionStatusSection config={config} />
                        <ApiKeySection config={config} />
                        <RoutingToggleSection config={config} />
                        {config.migrationInfo && <MigrationInfoSection migrationInfo={config.migrationInfo} />}
                    </>
                )}
            </PageContent>
        </PageContainer>
    );
}

export default SurveyIntegration;
